import { GlobalState } from '@/redux/store';

export const getArticle = (state: GlobalState) => state.article.article;

export const getArticleLoaded = (state: GlobalState) => state.article.loaded;

export const getArticleLoading = (state: GlobalState) => state.article.loading;

export const getArticleError = (state: GlobalState) => state.article.error;
